export default "__VITE_ASSET__CKI$YxUl__"